var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_177",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_177",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD7ElEQVR4nO2aO48URxCA52weAQf8ANuyAcniZQuRIgPODiMh2OmaDSBDHCH/wGfIjTgOr+WUg626iXjpHBh8AQI7QOLYqtk9iBDgNwk+J0igQT27tmdnj2XnsTu93JRU0gTTXf1NVVdX97RlFVJIIYUU8paKQ/WdivgUkMwByoIi+QdI/Cy11WdDofwIxCe1zcFS+v6IIg8U8f2s4WJowyG29Vj6ylq6WNuokH/KEbRdUW6DO7+hL7AO8S4g+SN3yA5ofuoQf54pLLi1PYD8PHe410M/d8jbnQlsGRsfAcqfuUP14Oky8qZ0tL4/AsQ/5w7Tu95KlchgpuYYABFLbeRScu+iLOQNENJr4N5979D0vfeBeLbLe41EvA7VdxoA+Z9q0H/HVkb+oOv7ruyIDQzEJ4cWGPmrBMAylzdku/Kshm7C8vdvePdGbGCVYemoSB4B8RRUZax0sbb5yPn5NVr1s43ePkV8DkgeZ/ZxUBbiexh5MQPDTwBlfM/c3Io32ZuY8N/RNToQP0xvlxfjA1PqELx84FJjbVy7uo1CuZLW/mCBkc9qj1kJRbcNpsBwAPPlpWDBvfeJIpkEYtF73OY+lwVIzjhU374UdBpPDwYY5Uk0jMdmH6wGkooiftml3YsgcbmyKtz28PSDdUD8q8HAfDQK2zyp6Dk6bkShddIzEljppcd13w33oVC+TTAlpsJ96AwfZHvTgCEy0Oac7RLGXcLbrnrbIl7+xjhgG719kfZnEk2LIFr4dFtf1dp+44DLWP+43SvsJQZG5nBfuiIzDhhcGc2sUkP+u60vV0aNAz4QWY70oFOE9LPO5ckw4PJyC2l7uSUtRXwu3F6Xi3qJiQ2s27iyNTKWinHAQPI4ug1s7XNjfjiZHJLCQ3yYkWNtfbiyCoiv9wyL/MP4d3dWtn80OZ5kLAMBVsS/dGTrJvRU1/AONg8yGYUF9856QP7NWGAIvCRXltoe6nJRJyOdgYM1GnkxeCb+Ojpn/98Ty7Wk4xgYMATKU2kPAJLM/xyBRetVXTDEtqvDOIVnkwNj8kopNKf/AuQTvRzitbLxeNINf7dKrSfJ9A9/c1mpOOR9UUbeEtTGrowGz82iopJk6cn0mFbFOqkwTfn60P9qgXge/nLof6ZBDLWrtU/fht+lfm/eZS8+bEv01aDcAWKqQ95BK92VB7k1RN69aaWV0gXvQyOvK3XCPtX3yKwsxCFvt+nXlmz0PssENnwxTZH8bqJnbeS9Vj8E3PkNRs1p5Jt6yll9Fd8f0VeDFEk9L9DAdrV2yBq0gCs7FMlE8BOMpJHJrYFOL+o+G9pGYCvJDZ1CCimkkEKs4ZBX2+qBGgLrJcYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.8930854d7d08b3c57c9b6ca7f4bc2ff9.svg";
export { ForwardRef as ReactComponent };